export default "__VITE_ASSET__OfmC8HY0__"